import {
  ProgressIndicator,
  PrimaryButton,
  DefaultButton,
  Announced,
} from '@fluentui/react';
import { useDownloadData } from '../context';
import { useAnalytics } from '@msrceng/analytics';
import { useTranslation } from 'react-i18next';
import { useLocalStorageState } from '@msrceng/component';
import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import { WarningBanner } from './WarningBanner';

/**
 * UX for downloading the data.
 */
export const DownloadFooter = () => {
  const [t] = useTranslation('download');
  const [downloadClicked, setDownloadClicked] = useState<boolean>(false);
  const { isDownloading, percent, setIsDownloading, disabled } =
    useDownloadData();
  const { appInsights } = useAnalytics();
  const [
    downloadProgressAnnouncedMessage,
    setDownloadProgressAnnouncedMessage,
  ] = useState<string | undefined>();

  const [data] = useLocalStorageState<{
    startDate?: Date;
    endDate?: Date;
  }>('date-selector');

  // Note: footer tag added to be able to test the footer content
  return (
    <footer data-testid='download-footer'>
      <WarningBanner downloadClicked={downloadClicked} />
      {isDownloading && (
        <ProgressIndicator label={t('Progress')} percentComplete={percent} />
      )}
      {downloadProgressAnnouncedMessage && (
        <Announced message={downloadProgressAnnouncedMessage} />
      )}
      <PrimaryButton
        disabled={isDownloading || disabled}
        iconProps={{ iconName: 'DownloadDocument' }}
        onClick={() => {
          //TODO: we want to use ' CorrelationId: ' + uuidv4() in appInsights for future  request.
          appInsights?.trackEvent?.({
            name: 'UpdateGuide.SearchDetails.DownloadClicked',
            properties: {
              correlationId: uuidv4().toString(),
              message: 'Start Download Clicked',
              startDate: data?.startDate?.toString(),
              endDate: data?.endDate?.toString(),
            },
          });
          setDownloadClicked(true);
          setIsDownloading(true);
          setDownloadProgressAnnouncedMessage(t('Download processing'));
        }}
      >
        {t(['Start', 'Download'], { ns: ['download', 'search'] })}
      </PrimaryButton>
      {isDownloading && (
        <DefaultButton
          iconProps={{ iconName: 'CircleStopSolid' }}
          onClick={() => {
            appInsights?.trackEvent?.({ name: 'Stop Download clicked' });
            setIsDownloading(false);
            setDownloadProgressAnnouncedMessage(undefined);
          }}
        >
          Stop download
        </DefaultButton>
      )}
    </footer>
  );
};
